import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'

class CustomerAgeingContentInput extends Component {

    constructor(props, context) {
        super(props, context)
        const content = this.props.value || {}
        this.state = {
            className: this.props.className || '',
            onChange: this.props.onChange || function () { },
        }
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-12">
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(CustomerAgeingContentInput)


// WEBPACK FOOTER //
// ./src/template/sections/content/customer-ageing-report/input.component.jsx